import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/kinekt-new/banner-back.webp";

function Banner() {
  return (
    <section
      className="banner_tamreeni banner-kinekt-new"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/kinekt-new/main-logo.webp"
                alt="TekRevol"
                className="logo_amj"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={532}
                height={533}
              />
            </div>
            <div className="banner_btn"></div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <div className="content">
              <h1 style={{ color: "#20a2be" }}>
                45% Boost in User Engagement with AI-Powered Patient Feedback
                for Kinekt
              </h1>
            </div>
            <Link
              style={{
                background: "#20A2BE",
                color: "#fff",
                border: "1px solid #20A2BE",
              }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Complimentary Consultation
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
